<template>
  <RevCard
    class="flex h-full items-center justify-center p-24"
    data-test="finder-card"
  >
    <h3 class="heading-2 text-center">{{ title }}</h3>
    <!-- Filter controls will be rendered here in a follow-up; the title is
         kept as a small category header for now. -->
    <slot />
  </RevCard>
</template>

<script lang="ts" setup>
import { RevCard } from '@ds/components/Card'

defineProps<{
  title: string
}>()
</script>
